module.exports = __webpack_public_path__ + "static/img/wdjs.8ff9194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wdjs.png
// module id = /FM8
// module chunks = 0